import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { makeURL } from '../helperFunctions';

const unauthorizedRedirectURL = `${process.env.REACT_APP_BRANDSOCIALVALUE}/my-account/`;


const isReportExportPath = () => window.location.pathname.includes('/report-export/');

const getTokenFromQueryParams = () => {
  const query = new URLSearchParams(window.location.search);
  return query.get('token');
};

const getJwtTokenFromCookies = () => {
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('mo_firebase_jwt_cookie='))
    ?.split('=')[1];

  return cookieValue;
};

const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_ENV !== 'production' && process.env.REACT_APP_ENV !== 'staging' ? 'http://localhost:8081/' : '',
});

// Set up a request interceptor
axiosInstance.interceptors.request.use(
  async config => {
    const tokenFromQueryParams = getTokenFromQueryParams();

    // Report export pages are opened by backend with token query param.
    // Use that token directly and avoid Firebase refresh dependency in headless Chromium.
    if (isReportExportPath() && tokenFromQueryParams) {
      config.headers['Authorization'] = `Bearer ${tokenFromQueryParams}`;
    }

    //If logged in user exists, send its token to backend
    if (!config.headers['Authorization']) {
      const { currentUser } = getAuth();
      if (currentUser) {
        const idTokenResult = await currentUser.getIdTokenResult(/* forceRefresh */ true);

        if (idTokenResult.token) {
          //Check if user session is expired
          const authTime = idTokenResult.claims.auth_time * 1000;
          const sessionDuration = 1000 * 60 * 60 * 24 * 1 + 1000 * 30;
          const millisecondsUntilExpiration = sessionDuration - (Date.now() - authTime);

          if (millisecondsUntilExpiration > 0) {
            config.headers['Authorization'] = `Bearer ${idTokenResult.token}`;
          }
        }
      }
    }

    if (!config.headers['Authorization'] && tokenFromQueryParams) {
      config.headers['Authorization'] = `Bearer ${tokenFromQueryParams}`;
    }

    const WPFirebaseToken = getJwtTokenFromCookies();
    if (WPFirebaseToken) config.headers['Custom-Header'] = `Bearer ${WPFirebaseToken}`;

    return config;
  },
  error => {
    // Handle request error here
    console.log('Catch error in axios interceptors', error);
    return Promise.reject(error);
  },
);

// Set up a response interceptor
axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const status = error?.response?.status;
    const data = error?.response?.data;

    // Handle 401: Unauthorized (User needs to login to WP, redirect to WP my account)
    if (status === 401) {
      if (isReportExportPath()) {
        return Promise.reject(error);
      }

      window.location.href = unauthorizedRedirectURL;
      return;
    }

    // Handle 404: survey id doesn't exist (Company tries to access non-existent survey)
    if (status === 404 && data?.error === 'Survey with sent ID does not exist') {
      if (isReportExportPath()) {
        return Promise.reject(error);
      }

      window.location.pathname = makeURL('/home');
      return;
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
